module.exports = __webpack_public_path__ + "static/media/asian-business-team-having-a-meeting-picture-id1131095961@3x.991e284c.png";